import PublicMainContainer from '../../../../layouts/public/PublicMainContainer'
import constants from '../../../../constants'
import {
  Alert,
  AlertTitle,
  Box,
  Button,
  Card,
  CardContent,
  CardHeader,
  Divider,
  Stack,
  Typography,
  useTheme,
} from '@mui/material'
import useLeaveRequestIndoTeamPageViewModel from './viewModel'
import { FormProvider } from 'react-hook-form'
import LeaveRequestFormInputs from '../components/LeaveRequestFormInputs'

const scopeNamePrefix = 'public-leave-request-indo-team'

export default function LeaveRequestIndoTeamPage() {
  const theme = useTheme()
  const viewModel = useLeaveRequestIndoTeamPageViewModel()

  return (
    <PublicMainContainer
      showBackButton
      wrapperBoxSx={{ bgcolor: constants.colors.neutrals.solitude, minHeight: '92vh', pt: 4, px: 2, pb: 16 }}
    >
      <Box sx={{ width: '100%', maxWidth: theme.breakpoints.values.sm, mx: 'auto' }}>
        {viewModel.addDataStatus.isError ? (
          <Alert severity='error' variant='standard' elevation={5} sx={{ mb: 2 }}>
            <AlertTitle>Error!</AlertTitle>
            Please kindly try again later...
          </Alert>
        ) : null}
        {viewModel.addDataStatus.isSuccess ? (
          <Card elevation={5}>
            <CardContent sx={{ p: 0, height: 12, bgcolor: constants.colors.neutrals.black }} />
            <CardHeader
              title={'Thank You :)'}
              subheader={
                "You'll get an email confirmation once HR redsponds.\nDon't forget to set your Slack status to 'Out of Office' or 'Sick Leave' after approval."
              }
              slotProps={{ title: { variant: 'h4' }, subheader: { variant: 'body1', whiteSpace: 'pre-wrap' } }}
            />
            <Divider />
            <CardContent>
              <Typography
                variant='subtitle2'
                color='primary.main'
                onClick={viewModel.resetPage}
                sx={{ cursor: 'pointer' }}
              >
                {'Submit another response.'}
              </Typography>
            </CardContent>
          </Card>
        ) : (
          <form onSubmit={viewModel.formHook.handleSubmit(viewModel.onSubmit)}>
            <Card elevation={5}>
              <CardContent sx={{ p: 0, height: 12, bgcolor: constants.colors.neutrals.black }} />
              <CardHeader
                title={'Leave Request Form Indo Team'}
                subheader={'Please submit the times you need to take off work and the type of leave you are taking.'}
                slotProps={{ title: { variant: 'h4' }, subheader: { variant: 'subtitle2' } }}
              />
              <CardContent>
                <Typography variant='subtitle2' color='error.main'>
                  {'* Indicates required'}
                </Typography>
              </CardContent>
              <Divider />
              <FormProvider {...viewModel.formHook}>
                <LeaveRequestFormInputs scopeNamePrefix={scopeNamePrefix} />
              </FormProvider>
            </Card>
            <Stack direction='row' gap={2} alignItems={'center'} justifyContent={'space-between'} mt={2}>
              <Button
                type='submit'
                size='large'
                variant='contained'
                disabled={viewModel.addDataStatus.isLoading}
                loading={viewModel.addDataStatus.isLoading}
              >
                Submit
              </Button>
              <Button type='reset' size='large' variant='text' onClick={viewModel.resetPage}>
                Clear form
              </Button>
            </Stack>
          </form>
        )}
      </Box>
    </PublicMainContainer>
  )
}
